var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { coreUserService } from "../../modules/users";
import { changeQueryParamters } from "flavr-common";
import { fetchWithTimeout } from "./api.service";
export function getSessionList() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetchWithTimeout(`/api/v1/sessionlist`);
        if (!response.ok) {
            throw new Error("Could not fetch Sessions!");
        }
        try {
            return (yield response.json()).sessions;
        }
        catch (error) {
            throw new Error("Could not parse response!");
        }
    });
}
export function getLayoutList() {
    return __awaiter(this, void 0, void 0, function* () {
        const clientId = coreUserService.getLocalUser().clientId;
        const response = yield fetchWithTimeout(`/api/v1/sessiontypes/${clientId}`);
        if (!response.ok) {
            throw new Error("Could not fetch Layouts!");
        }
        try {
            return (yield response.json()).layouters;
        }
        catch (error) {
            throw new Error("Could not parse response!");
        }
    });
}
export function deleteSession(sessionName) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetchWithTimeout(`/api/v1/session/${sessionName}`, {
            method: "DELETE"
        });
        if (!response.ok) {
            throw new Error("Could not delete Session!");
        }
    });
}
export function asyncCallWithTimeout(asyncPromise_1, timeLimit_1) {
    return __awaiter(this, arguments, void 0, function* (asyncPromise, timeLimit, timeoutError = new Error("promise timed out")) {
        let timeoutHandle;
        const timeoutPromise = new Promise((_resolve, reject) => {
            timeoutHandle = self.setTimeout(() => {
                reject(timeoutError);
            }, timeLimit);
        });
        return yield Promise.race([asyncPromise, timeoutPromise]).then((result) => {
            clearTimeout(timeoutHandle);
            return result;
        });
    });
}
export function getSessionDetails(sessionName) {
    return __awaiter(this, void 0, void 0, function* () {
        const clientId = coreUserService.getLocalUser().clientId;
        const response = yield asyncCallWithTimeout(fetch(`/api/v1/session/${sessionName}/${clientId}`), 1000);
        if (!response.ok) {
            throw new Error("Could not fetch Session Details!");
        }
        return response.json();
    });
}
export function createSessionLayout(sessionName, layouter) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetch(`/api/v1/session/new/${sessionName}/${layouter}`);
    });
}
export function createSessionWorld(sessionName, layouterName) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetch(`/world/${layouterName}/${sessionName}`);
    });
}
export function joinSession(sessionName, layouterName, isWorld) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!isWorld) {
            const params = {};
            params.session = sessionName;
            params.room = "";
            params.layout = "";
            if (layouterName) {
                params.room = `root/[${layouterName}]`;
                params.layout = layouterName;
            }
            window.location.replace(changeQueryParamters(location.search, params));
        }
        else {
            if (layouterName) {
                const response = yield fetch(`/world/${layouterName}/${sessionName}`);
                window.location.replace(response.url);
            }
            else {
                const response = yield fetch(`/world/${sessionName}`);
                window.location.replace(response.url);
            }
        }
        localStorage.setItem("session", sessionName);
    });
}
